import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../utilities/classNames';
import { evaluate } from '../../utilities/props';
import Button from './Button';

const ToggleButton = ({
  children,
  className,
  onChange = () => {},
  value = false,
  ...props
}) => {
  value = Boolean(evaluate(value));
  const [enabled, setEnabled] = useState(value);

  return (
    <Button
      className={cn('ToggleButton', className)}
      onClick={() => {
        setEnabled(!enabled);
        onChange(!enabled);
      }}
      {...props}
    >
      {children && children(enabled)}
    </Button>
  );
};

ToggleButton.propTypes = {
  children: PropTypes.func,
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
};

export default ToggleButton;
